const forgot_password = {
  current_password: 'Contraseña actual',
};

export default forgot_password;
